<template>
   

   <NavComponents />
  
  <div class="container">
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="目录" name="menu">
            <LearnChapter />
        </el-tab-pane>
        <el-tab-pane label="学情分析" name="certifica">
          <LearnCertifica/>
        </el-tab-pane>
        <el-tab-pane label="考试" name="exam">
          <LearnExam/>
        </el-tab-pane>
        <el-tab-pane label="作业" name="homework">
          <LearnHomework/>
        </el-tab-pane>
        <el-tab-pane label="公告" name="notice">
          <LearnNotice/>
        </el-tab-pane>
        <el-tab-pane label="课程介绍" name="introduce">
          <LearnIntroCourse/>
        </el-tab-pane>
    </el-tabs>
  </div>
  <NavFooter/>
</template>

<script setup>
import NavComponents from "@/components/nav/NavComponents.vue";
import NavFooter from '@/components/nav/NavFooter.vue';
import LearnChapter from '@/components/course/chapter/LearnChapter.vue';
import LearnIntroCourse from '@/components/course/LearnIntroCourse';
import LearnNotice from '@/components/course/LearnNotice';
import LearnHomework from '@/components/course/homework/LearnHomework.vue'
import LearnExam from '@/components/course/exam/LearnExam'
import LearnCertifica from '@/components/course/certifica/LearnCertifica'


import { ref, onMounted } from "vue";
import $ from "jquery";
import router from "@/router/index";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";

const Route = useRoute(); //获取到值

const courseId = ref("");
const activeName = ref("certifica");
onMounted(() => {
  // 获取路由参数并设置为 current_page
  courseId.value = Route.params.courseId || '';
  preAuth();
});

const preAuth = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/course/hasPreAuth",
    data: {
      courseId: courseId.value,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        console.log("放行");
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
        router.push({ name: "home" });
      }
    },
    error() {
      ElMessage({
        type: "error",
        message: "权限不足",
      });
      router.push({ name: "home" });
    },
  });
}


</script>

<style>

</style>